import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, mergeProps as _mergeProps, createTextVNode as _createTextVNode, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/multi-people.svg'
import _imports_1 from '@/app/ui/assets/svg/info-red.svg'
import _imports_2 from '@/app/ui/assets/svg/attachment.svg'


const _hoisted_1 = { class: "pt-8 bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative w-full" }
const _hoisted_2 = { class: "p-6" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "text-16px font-semibold" }, " Pembaruan Harga Induk Client ", -1)
const _hoisted_4 = { class: "flex items-center justify-between" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "text-12px xxl:text-14px text-gray-lp-600 font-normal" }, " Sebelum menyetujui permintaan ini, pastikan seluruh data Client sudah benar dan sesuai. ", -1)
const _hoisted_6 = { class: "flex items-center gap-x-4" }
const _hoisted_7 = { class: "flex flex-row items-center px-6 py-3" }
const _hoisted_8 = { class: "w-1/5 pr-6 text-center" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  class: "mx-auto mb-2",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_10 = { class: "text-20px font-semibold break-words ellipsis-2" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "font-normal text-gray-lp-800 text-12px mt-6" }, " Saldo Tersedia ", -1)
const _hoisted_12 = {
  key: 0,
  class: "my-1 text-16px text-black-lp-300"
}
const _hoisted_13 = { class: "w-4/5 pl-6 border-l" }
const _hoisted_14 = { class: "grid grid-cols-3 gap-x-6" }
const _hoisted_15 = { class: "flex items-center gap-x-4" }
const _hoisted_16 = {
  key: 0,
  class: "rounded items-start flex text-12px bg-gray-lp-200 text-gray-lp-800 p-2 mt-2"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("img", {
  class: "mr-4",
  src: _imports_1,
  alt: "info"
}, null, -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "flex items-center" }
const _hoisted_20 = {
  key: 0,
  class: "rounded items-start flex text-12px bg-gray-lp-200 text-gray-lp-800 p-2 mt-2"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("img", {
  class: "mr-4",
  src: _imports_1,
  alt: "info"
}, null, -1)
const _hoisted_22 = { class: "py-3" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "font-normal text-gray-lp-800 text-12px mb-2" }, " Tanggal Disetujui ", -1)
const _hoisted_24 = { class: "my-1 text-black-lp-300" }
const _hoisted_25 = { class: "text-gray-lp-300" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "flex items-center" }
const _hoisted_28 = {
  key: 0,
  class: "rounded items-start flex text-12px bg-gray-lp-200 text-gray-lp-800 p-2 mt-2"
}
const _hoisted_29 = /*#__PURE__*/_createVNode("img", {
  class: "mr-4",
  src: _imports_1,
  alt: "info"
}, null, -1)
const _hoisted_30 = {
  key: 1,
  class: "py-3"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "font-normal text-gray-lp-800 text-12px mb-2" }, " Tanggal Ditolak ", -1)
const _hoisted_32 = { class: "my-1 text-black-lp-300" }
const _hoisted_33 = { class: "text-gray-lp-300" }
const _hoisted_34 = {
  key: 1,
  class: "flex gap-x-6 text-16px border-b border-gray-lp-400"
}
const _hoisted_35 = { class: "p-6 space-y-6 relative" }
const _hoisted_36 = { class: "flex justify-between" }
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_40 = { class: "flex" }
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_42 = {
  key: 7,
  class: "py-3"
}
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "border-b-2" }, null, -1)
const _hoisted_44 = {
  key: 9,
  class: "py-3"
}
const _hoisted_45 = /*#__PURE__*/_createVNode("div", { class: "border-b-2" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_49 = { class: "space-y-2" }
const _hoisted_50 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-200 text-gray-lp-800 text-12px xxl:text-14px font-medium py-1 px-4" }, " Harga saat ini ", -1)
const _hoisted_51 = { class: "py-6" }
const _hoisted_52 = { class: "px-4 flex flex-row w-full gap-x-4" }
const _hoisted_53 = { class: "flex flex-row w-5/12" }
const _hoisted_54 = { class: "flex my-1 items-center" }
const _hoisted_55 = { class: "flex flex-row flex-wrap w-7/12" }
const _hoisted_56 = { class: "flex my-1 items-start" }
const _hoisted_57 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "attachment"
}, null, -1)
const _hoisted_58 = { class: "ml-2 w-40 truncate" }
const _hoisted_59 = {
  key: 0,
  class: "pt-2 pb-3 w-full"
}
const _hoisted_60 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_61 = /*#__PURE__*/_createVNode("div", { class: "w-3/12" }, null, -1)
const _hoisted_62 = { class: "flex items-start my-1" }
const _hoisted_63 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "attachment"
}, null, -1)
const _hoisted_64 = { class: "ml-2 w-40 truncate" }
const _hoisted_65 = { class: "space-y-2" }
const _hoisted_66 = { class: "flex flex-row items-center space-x-4 bg-gray-lp-200 text-gray-lp-800 text-12px xxl:text-14px font-medium py-2 px-4 rounded" }
const _hoisted_67 = /*#__PURE__*/_createVNode("span", null, "Pembaruan Harga :", -1)
const _hoisted_68 = { class: "py-6" }
const _hoisted_69 = { class: "px-4 flex flex-row w-full gap-x-4" }
const _hoisted_70 = { class: "flex flex-row w-5/12" }
const _hoisted_71 = { class: "flex w-full items-center gap-x-4" }
const _hoisted_72 = { class: "my-1" }
const _hoisted_73 = {
  key: 0,
  class: "flex flex-row flex-wrap w-7/12"
}
const _hoisted_74 = { class: "flex items-start my-1" }
const _hoisted_75 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "attachment"
}, null, -1)
const _hoisted_76 = { class: "ml-2 w-40 truncate" }
const _hoisted_77 = {
  key: 0,
  class: "pt-2 pb-3 w-full"
}
const _hoisted_78 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_79 = /*#__PURE__*/_createVNode("div", { class: "w-3/12" }, null, -1)
const _hoisted_80 = { class: "flex items-start my-1" }
const _hoisted_81 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "attachment"
}, null, -1)
const _hoisted_82 = { class: "ml-2 w-40 truncate" }
const _hoisted_83 = /*#__PURE__*/_createVNode("div", { class: "w-5/12" }, null, -1)
const _hoisted_84 = /*#__PURE__*/_createVNode("div", { class: "w-3/12" }, null, -1)
const _hoisted_85 = { class: "flex items-start my-1" }
const _hoisted_86 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "attachment"
}, null, -1)
const _hoisted_87 = { class: "ml-2 w-40 truncate" }
const _hoisted_88 = /*#__PURE__*/_createVNode("div", { class: "w-5/12" }, null, -1)
const _hoisted_89 = /*#__PURE__*/_createVNode("div", { class: "w-3/12" }, null, -1)
const _hoisted_90 = { class: "w-4/12 pt-6 text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_Chips = _resolveComponent("Chips")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_CreateUpdate = _resolveComponent("CreateUpdate")!
  const _component_Title = _resolveComponent("Title")!
  const _component_DetailParentClient = _resolveComponent("DetailParentClient")!
  const _component_DetailBranchClient = _resolveComponent("DetailBranchClient")!
  const _component_DetailTaxInformation = _resolveComponent("DetailTaxInformation")!
  const _component_DetailContactInformation = _resolveComponent("DetailContactInformation")!
  const _component_DetailConfigRetur = _resolveComponent("DetailConfigRetur")!
  const _component_DetailDeliveryOrder = _resolveComponent("DetailDeliveryOrder")!
  const _component_DetailCodrej = _resolveComponent("DetailCodrej")!
  const _component_DetailParentBranch = _resolveComponent("DetailParentBranch")!
  const _component_DetailBillingInformation = _resolveComponent("DetailBillingInformation")!
  const _component_DetailBankInformation = _resolveComponent("DetailBankInformation")!
  const _component_DetailBankSettlementInformation = _resolveComponent("DetailBankSettlementInformation")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Confirmation = _resolveComponent("Confirmation")!
  const _component_edit_basic_information = _resolveComponent("edit-basic-information")!
  const _component_EditCurrentPeriode = _resolveComponent("EditCurrentPeriode")!
  const _component_RenewRates = _resolveComponent("RenewRates")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_freeze_unfreeze_popup = _resolveComponent("freeze-unfreeze-popup")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Breadcrumb),
      _createVNode(_component_DetailLayout, {
        onBack: _ctx.goBack,
        loading: _ctx.isLoading,
        error: _ctx.isError,
        errorType: _ctx.errorCause,
        onTryAgain: _ctx.getDetail,
        title: _ctx.detailData.clientName,
        "full-page": true,
        "vertical-separator": false
      }, {
        data: _withCtx(() => [
          (_ctx.isApproveAble && _ctx.statusRenewal === 'requested')
            ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createVNode("div", _hoisted_4, [
                      _hoisted_5,
                      _createVNode("div", _hoisted_6, [
                        _createVNode(_component_lp_button, {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmation(1))),
                          title: "Tolak",
                          outline: "",
                          textColor: "red-lp-200",
                          color: "red-lp-200"
                        }),
                        _createVNode(_component_lp_button, {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmation(0))),
                          title: "Setujui",
                          textColor: "white",
                          color: "red-lp-300"
                        })
                      ])
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_Card, null, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode("div", _hoisted_10, _toDisplayString(_ctx.detailData.clientName), 1),
                  (_ctx.isParentClient)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _hoisted_11,
                        (!_ctx.loadingBalance)
                          ? (_openBlock(), _createBlock("div", _hoisted_12, _toDisplayString(_ctx.convertClientBalance), 1))
                          : (_openBlock(), _createBlock(_component_skeleton, {
                              key: 1,
                              class: "mx-auto my-1",
                              width: "10rem"
                            }))
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, [
                    _createVNode("div", null, [
                      _createVNode(_component_DataWrapper, { label: "Status Client" }, {
                        default: _withCtx(() => [
                          _createVNode("div", _hoisted_15, [
                            _createVNode(_component_Chips, _mergeProps({ class: "my-2" }, 
                          _ctx.translateStatusClient(
                            _ctx.detailData.clientIsBanned ? 'freeze' : 'active'
                          )
                        , { rounded: "" }), null, 16),
                            (_ctx.isEditAble)
                              ? (_openBlock(), _createBlock(_component_lp_button, {
                                  key: 0,
                                  compact: "",
                                  "text-color": "red-lp-100",
                                  flat: "",
                                  title: "Ubah",
                                  onClick: _ctx.handleFreezeUnFreeze
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }),
                      (_ctx.detailData.clientIsBanned)
                        ? (_openBlock(), _createBlock("div", _hoisted_16, [
                            _hoisted_17,
                            _createTextVNode(" " + _toDisplayString(_ctx.detailData.clientBannedReason), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_CreateUpdate, {
                        createdAt: _ctx.detailData.clientCreatedAt,
                        createdBy: _ctx.detailData.clientCreatedBy,
                        updatedAt: _ctx.detailData.clientUpdatedAt,
                        updatedBy: _ctx.detailData.clientUpdatedBy
                      }, null, 8, ["createdAt", "createdBy", "updatedAt", "updatedBy"])
                    ]),
                    (_ctx.isParentClient)
                      ? (_openBlock(), _createBlock("div", _hoisted_18, [
                          _createVNode(_component_DataWrapper, { label: "Status Harga Saat Ini" }, {
                            default: _withCtx(() => [
                              _createVNode("div", _hoisted_19, [
                                _createVNode(_component_Chips, _mergeProps({ class: "my-2" }, _ctx.translateStatusClient(_ctx.statusRates), { rounded: "" }), null, 16)
                              ])
                            ]),
                            _: 1
                          }),
                          (_ctx.statusRatesCaption)
                            ? (_openBlock(), _createBlock("div", _hoisted_20, [
                                _hoisted_21,
                                _createTextVNode(" " + _toDisplayString(_ctx.statusRatesCaption), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _createVNode("div", _hoisted_24, _toDisplayString(_ctx.approvedAt), 1),
                            _createVNode("div", _hoisted_25, _toDisplayString(_ctx.detailData.clientCurrentRate.clientStatusUpdatedBy), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (
                    _ctx.isParentClient &&
                      _ctx.detailData.clientRenewalRate.clientCustomRateId !== 0
                  )
                      ? (_openBlock(), _createBlock("div", _hoisted_26, [
                          _createVNode(_component_DataWrapper, { label: "Status Pembaruan" }, {
                            default: _withCtx(() => [
                              _createVNode("div", _hoisted_27, [
                                _createVNode(_component_Chips, _mergeProps({ class: "my-1" }, _ctx.translateStatusClient(_ctx.statusRenewal), {
                                  label: 
                          _ctx.statusRenewal === 'uploading'
                            ? `${_ctx.translateStatusClient(_ctx.statusRenewal).label} ${
                                _ctx.detailData.dataProcessed
                              }/${_ctx.detailData.totalData}`
                            : _ctx.translateStatusClient(_ctx.statusRenewal).label
                        ,
                                  rounded: ""
                                }), null, 16, ["label"])
                              ])
                            ]),
                            _: 1
                          }),
                          (_ctx.statusRenewalCaptions)
                            ? (_openBlock(), _createBlock("div", _hoisted_28, [
                                _hoisted_29,
                                _createTextVNode(" " + _toDisplayString(_ctx.statusRenewalCaptions), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.statusRenewal === 'rejected')
                            ? (_openBlock(), _createBlock("div", _hoisted_30, [
                                _hoisted_31,
                                _createVNode("div", _hoisted_32, _toDisplayString(_ctx.statusRenewalUpdateAt), 1),
                                _createVNode("div", _hoisted_33, _toDisplayString(_ctx.detailData.clientStatusUpdatedBy), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          (_ctx.isParentClient)
            ? (_openBlock(), _createBlock("div", _hoisted_34, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                  return (_openBlock(), _createBlock("button", {
                    key: tab.name,
                    onClick: ($event: any) => (_ctx.changeTabs(tab.name)),
                    class: 
              `pb-2 px-6 font-semibold hover:text-red-lp-100 focus:outline-none ${
                _ctx.isTabActive(tab.name)
                  ? 'text-red-lp-100 border-b-2 border-red-lp-100'
                  : 'text-gray-lp-600'
              }`
            
                  }, _toDisplayString(tab.title), 11, ["onClick"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.tabActive === 'detail-client')
            ? (_openBlock(), _createBlock(_component_Card, { key: 2 }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_35, [
                    _createVNode("div", _hoisted_36, [
                      (_ctx.isParentClient)
                        ? (_openBlock(), _createBlock(_component_Title, {
                            key: 0,
                            label: "Detail Induk Client"
                          }))
                        : (_openBlock(), _createBlock(_component_Title, {
                            key: 1,
                            label: "Detail Cabang Client"
                          }))
                    ]),
                    (_ctx.isEditAble && _ctx.statusRates !== 'expired')
                      ? (_openBlock(), _createBlock(_component_lp_button, {
                          key: 0,
                          class: "absolute top-0 right-0 mr-6",
                          "text-color": "red-lp-300",
                          title: "Ubah",
                          outline: "",
                          iconLeft: "pencil-alt",
                          onClick: _ctx.setShowEditBasicInformation
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.isParentClient)
                      ? (_openBlock(), _createBlock(_component_DetailParentClient, {
                          key: 1,
                          detailData: _ctx.detailData
                        }, null, 8, ["detailData"]))
                      : (_openBlock(), _createBlock(_component_DetailBranchClient, {
                          key: 2,
                          detailData: _ctx.detailData
                        }, null, 8, ["detailData"])),
                    _hoisted_37,
                    (_ctx.isParentClient)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                          _createVNode(_component_DetailTaxInformation, { detailData: _ctx.detailData }, null, 8, ["detailData"]),
                          _hoisted_38
                        ], 64))
                      : _createCommentVNode("", true),
                    _createVNode(_component_DetailContactInformation, { detailData: _ctx.detailData }, null, 8, ["detailData"]),
                    (!_ctx.isParentClient)
                      ? (_openBlock(), _createBlock(_component_DetailConfigRetur, {
                          key: 4,
                          detailData: _ctx.detailData
                        }, null, 8, ["detailData"]))
                      : _createCommentVNode("", true),
                    (_ctx.isParentClient)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 5 }, [
                          _hoisted_39,
                          _createVNode(_component_Title, { label: "Informasi Pembayaran" }),
                          _createVNode("div", _hoisted_40, [
                            _createVNode(_component_DataWrapper, {
                              class: "w-1/2",
                              label: "Metode Pembayaran",
                              value: _ctx.detailData.clientPaymentMethod?.name
                            }, null, 8, ["value"])
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.detailData.clientIsDo)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 6 }, [
                          _hoisted_41,
                          _createVNode(_component_DetailDeliveryOrder, { detailData: _ctx.detailData }, null, 8, ["detailData"])
                        ], 64))
                      : _createCommentVNode("", true),
                    (!_ctx.isParentClient)
                      ? (_openBlock(), _createBlock("div", _hoisted_42, [
                          _hoisted_43
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isParentClient && _ctx.detailData.clientIsCod)
                      ? (_openBlock(), _createBlock(_component_DetailCodrej, {
                          key: 8,
                          detailData: _ctx.detailData
                        }, null, 8, ["detailData"]))
                      : _createCommentVNode("", true),
                    (!_ctx.isParentClient && _ctx.detailData.clientIsCod)
                      ? (_openBlock(), _createBlock("div", _hoisted_44, [
                          _hoisted_45
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isParentClient)
                      ? (_openBlock(), _createBlock(_component_DetailParentBranch, {
                          key: 10,
                          detailData: _ctx.detailData
                        }, null, 8, ["detailData"]))
                      : _createCommentVNode("", true),
                    (_ctx.isParentClient)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 11 }, [
                          _hoisted_46,
                          _createVNode(_component_DetailBillingInformation, { detailData: _ctx.detailData }, null, 8, ["detailData"]),
                          _hoisted_47,
                          _createVNode(_component_DetailBankInformation, { detailData: _ctx.detailData }, null, 8, ["detailData"]),
                          _hoisted_48,
                          _createVNode(_component_DetailBankSettlementInformation, { detailData: _ctx.detailData }, null, 8, ["detailData"])
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.tabActive === 'detail-rates-client')
            ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                _createVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createVNode(_component_Card, null, {
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_51, [
                        _createVNode("div", _hoisted_52, [
                          _createVNode("div", _hoisted_53, [
                            _createVNode(_component_DataWrapper, {
                              padded: true,
                              class: "w-4/12 whitespace-no-wrap",
                              label: "Status Harga"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Chips, _mergeProps({ class: "my-1" }, _ctx.translateStatusClient(_ctx.statusRates), { rounded: "" }), null, 16)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DataWrapper, {
                              padded: true,
                              class: "w-8/12 whitespace-no-wrap",
                              label: "Periode Harga"
                            }, {
                              default: _withCtx(() => [
                                _createVNode("div", _hoisted_54, [
                                  _createVNode("div", null, _toDisplayString(_ctx.basicRatePeriod), 1),
                                  (_ctx.statusRates !== 'expired' && _ctx.isEditAble)
                                    ? (_openBlock(), _createBlock(_component_lp_button, {
                                        key: 0,
                                        "text-color": "red-lp-300",
                                        title: "Ubah",
                                        compact: "",
                                        class: "ml-2",
                                        flat: "",
                                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setEditCurrentRate(true)))
                                      }))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode("div", _hoisted_55, [
                            (_ctx.detailData.clientCurrentRate.clientFileNameBaseRate)
                              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                  _createVNode(_component_DataWrapper, {
                                    padded: true,
                                    class: "w-5/12 break-words",
                                    label: "Versi Harga Normal",
                                    value: 
                          _ctx.detailData.clientCurrentRate.clientVersionBaseRate
                        
                                  }, null, 8, ["value"]),
                                  _createVNode(_component_DataWrapper, {
                                    padded: true,
                                    class: "w-3/12 whitespace-no-wrap",
                                    label: "Diskon",
                                    value: 
                          `${_ctx.detailData.clientCurrentRate.clientDiscountBaseRate}%`
                        
                                  }, null, 8, ["value"]),
                                  _createVNode(_component_DataWrapper, {
                                    padded: true,
                                    class: "w-4/12 whitespace-no-wrap",
                                    label: "Berkas Lampiran"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode("div", _hoisted_56, [
                                        _hoisted_57,
                                        _createVNode("div", _hoisted_58, _toDisplayString(_ctx.detailData.clientCurrentRate
                                ?.clientFileNameBaseRate), 1),
                                        _createVNode(_component_lp_button, {
                                          onClick: _cache[4] || (_cache[4] = ($event: any) => (
                              _ctx.download(
                                _ctx.detailData.clientCurrentRate.clientFileBaseRate,
                                _ctx.detailData.clientCurrentRate
                                  .clientFileNameBaseRate
                              )
                            )),
                                          class: "ml-2",
                                          "text-color": "red-lp-300",
                                          flat: "",
                                          compact: "",
                                          icon: "download"
                                        })
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ], 64))
                              : _createCommentVNode("", true),
                            (
                        _ctx.detailData.clientCurrentRate
                          .clientFileNameCustomRate !== ''
                      )
                              ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                  (
                          _ctx.detailData.clientCurrentRate.clientFileNameBaseRate
                        )
                                    ? (_openBlock(), _createBlock("div", _hoisted_59, [
                                        _hoisted_60
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_DataWrapper, {
                                    padded: true,
                                    class: "w-5/12 break-words",
                                    label: "Versi Harga Khusus",
                                    value: 
                          _ctx.detailData.clientCurrentRate.clientVersionCustomRate
                        
                                  }, null, 8, ["value"]),
                                  _hoisted_61,
                                  _createVNode(_component_DataWrapper, {
                                    padded: true,
                                    class: "w-4/12 whitespace-no-wrap",
                                    label: "Berkas Lampiran Asli"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode("div", _hoisted_62, [
                                        _hoisted_63,
                                        _createVNode("div", _hoisted_64, _toDisplayString(_ctx.detailData.clientCurrentRate
                                ?.clientFileNameCustomRate), 1),
                                        _createVNode(_component_lp_button, {
                                          onClick: _cache[5] || (_cache[5] = ($event: any) => (
                              _ctx.download(
                                _ctx.detailData.clientCurrentRate
                                  .clientFileCustomRate,
                                _ctx.detailData.clientCurrentRate
                                  .clientFileNameCustomRate
                              )
                            )),
                                          "text-color": "red-lp-300",
                                          class: "ml-2",
                                          flat: "",
                                          compact: "",
                                          icon: "download"
                                        })
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("div", _hoisted_65, [
                  _createVNode("div", _hoisted_66, [
                    _hoisted_67,
                    _createVNode(_component_lp_button, {
                      iconV2: "",
                      "icon-left": "bill-add",
                      "icon-color": "white",
                      "text-color": "white",
                      "text-size": 10,
                      small: "",
                      title: "Harga baru",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onAddRenewRates(true))),
                      disabled: _ctx.unableToRenewRates
                    }, null, 8, ["disabled"]),
                    _createVNode(_component_lp_button, {
                      iconV2: "",
                      "icon-left": "reload",
                      "icon-size": "4",
                      "icon-color": "red-lp-100",
                      "text-color": "red-lp-100",
                      "text-size": 10,
                      small: "",
                      outline: "",
                      title: "Perbarui Harga Saat Ini",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onUpdateRates(true))),
                      disabled: _ctx.isDisableUpdateRates
                    }, null, 8, ["disabled"])
                  ]),
                  (_ctx.detailData.clientRenewalRate.clientCustomRateId !== 0)
                    ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode("div", _hoisted_68, [
                            _createVNode("div", _hoisted_69, [
                              _createVNode("div", _hoisted_70, [
                                _createVNode(_component_DataWrapper, {
                                  padded: true,
                                  class: ["w-4/12 whitespace-no-wrap", 
                        `${_ctx.statusRenewal === 'uploading' ? 'w-8/12' : 'w-4/12'}`
                      ],
                                  label: "Status Harga"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode("div", _hoisted_71, [
                                      _createVNode(_component_Chips, _mergeProps({ class: "my-1" }, _ctx.translateStatusClient(_ctx.statusRenewal), {
                                        label: 
                            _ctx.statusRenewal === 'uploading'
                              ? `${
                                  _ctx.translateStatusClient(_ctx.statusRenewal).label
                                } ${_ctx.detailData.dataProcessed}/${
                                  _ctx.detailData.totalData
                                }`
                              : _ctx.translateStatusClient(_ctx.statusRenewal).label
                          ,
                                        rounded: ""
                                      }), null, 16, ["label"]),
                                      (
                            _ctx.statusRenewal === 'uploading' &&
                              _ctx.detailData.dataProcessed < _ctx.detailData.totalData &&
                              _ctx.priceTypeRenewRates !== 'basic'
                          )
                                        ? (_openBlock(), _createBlock(_component_lp_button, {
                                            key: 0,
                                            compact: "",
                                            "text-color": "red-lp-100",
                                            flat: "",
                                            title: "Coba Lagi",
                                            onClick: _ctx.retryUploadClientRate
                                          }, null, 8, ["onClick"]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["class"]),
                                (_ctx.statusRenewal !== 'uploading')
                                  ? (_openBlock(), _createBlock(_component_DataWrapper, {
                                      key: 0,
                                      padded: true,
                                      class: "w-8/12 whitespace-no-wrap",
                                      label: "Periode Harga"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode("div", _hoisted_72, _toDisplayString(_ctx.customRatePeriod), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              (_ctx.statusRenewal !== 'uploading')
                                ? (_openBlock(), _createBlock("div", _hoisted_73, [
                                    (_ctx.detailData.clientRenewalRate.clientVersionBaseRate)
                                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                          _createVNode(_component_DataWrapper, {
                                            padded: true,
                                            class: "w-5/12 break-words",
                                            label: "Versi Harga Normal",
                                            value: 
                          _ctx.detailData.clientRenewalRate.clientVersionBaseRate
                        
                                          }, null, 8, ["value"]),
                                          _createVNode(_component_DataWrapper, {
                                            padded: true,
                                            class: "w-3/12 whitespace-no-wrap",
                                            label: "Diskon",
                                            value: 
                          `${
                            _ctx.detailData.clientRenewalRate.clientDiscountBaseRate
                              ? _ctx.detailData.clientRenewalRate
                                  .clientDiscountBaseRate
                              : '0'
                          }%`
                        
                                          }, null, 8, ["value"]),
                                          _createVNode(_component_DataWrapper, {
                                            padded: true,
                                            class: "w-4/12 whitespace-no-wrap",
                                            label: "Berkas Lampiran"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode("div", _hoisted_74, [
                                                _hoisted_75,
                                                _createVNode("div", _hoisted_76, _toDisplayString(_ctx.detailData.clientRenewalRate
                                ?.clientFileNameBaseRate), 1),
                                                _createVNode(_component_lp_button, {
                                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (
                              _ctx.download(
                                _ctx.detailData.clientRenewalRate
                                  ?.clientFileBaseRate,
                                _ctx.detailData.clientRenewalRate
                                  ?.clientFileNameBaseRate
                              )
                            )),
                                                  "text-color": "red-lp-300",
                                                  class: "ml-2",
                                                  flat: "",
                                                  compact: "",
                                                  icon: "download"
                                                })
                                              ])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_DataWrapper, {
                                            padded: true,
                                            class: "w-5/12 break-words",
                                            label: "Tanggal Aktif Harga",
                                            value: _ctx.formatDateWithoutTime(_ctx.getDetail.rateActiveDate)
                                          }, null, 8, ["value"])
                                        ], 64))
                                      : _createCommentVNode("", true),
                                    (
                        _ctx.detailData.clientRenewalRate?.clientVersionCustomRate
                      )
                                      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                          (
                          _ctx.detailData.clientRenewalRate?.clientVersionBaseRate
                        )
                                            ? (_openBlock(), _createBlock("div", _hoisted_77, [
                                                _hoisted_78
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_DataWrapper, {
                                            padded: true,
                                            class: "w-5/12 break-words",
                                            label: "Versi Harga Khusus",
                                            value: 
                          _ctx.detailData.clientRenewalRate.clientVersionCustomRate
                        
                                          }, null, 8, ["value"]),
                                          _hoisted_79,
                                          _createVNode(_component_DataWrapper, {
                                            padded: true,
                                            class: "w-4/12 whitespace-no-wrap",
                                            label: "Berkas Lampiran Asli"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode("div", _hoisted_80, [
                                                _hoisted_81,
                                                _createVNode("div", _hoisted_82, _toDisplayString(_ctx.detailData.clientRenewalRate
                                ?.clientFileNameCustomRate), 1),
                                                _createVNode(_component_lp_button, {
                                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (
                              _ctx.download(
                                _ctx.detailData.clientRenewalRate
                                  .clientFileCustomRate,
                                _ctx.detailData.clientRenewalRate
                                  .clientFileNameCustomRate
                              )
                            )),
                                                  "text-color": "red-lp-300",
                                                  class: "ml-2",
                                                  flat: "",
                                                  compact: "",
                                                  icon: "download"
                                                })
                                              ])
                                            ]),
                                            _: 1
                                          }),
                                          (
                          _ctx.detailData.clientRenewalRate
                            ?.clientStatusCustomRate === 'rejected' &&
                            _ctx.detailData.clientRenewalRate
                              ?.clientErrorFileCustomRate
                        )
                                            ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                                _hoisted_83,
                                                _hoisted_84,
                                                _createVNode(_component_DataWrapper, {
                                                  padded: true,
                                                  "border-failed": true,
                                                  class: "w-4/12 whitespace-no-wrap",
                                                  label: "Berkas Lampiran Gagal"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode("div", _hoisted_85, [
                                                      _hoisted_86,
                                                      _createVNode("div", _hoisted_87, _toDisplayString(_ctx.detailData.clientRenewalRate
                                  ?.clientErrorNameCustomRate), 1),
                                                      _createVNode(_component_lp_button, {
                                                        onClick: _cache[10] || (_cache[10] = ($event: any) => (
                                _ctx.download(
                                  _ctx.detailData.clientRenewalRate
                                    .clientErrorFileCustomRate,
                                  _ctx.detailData.clientRenewalRate
                                    .clientErrorNameCustomRate
                                )
                              )),
                                                        "text-color": "red-lp-300",
                                                        class: "ml-2",
                                                        flat: "",
                                                        compact: "",
                                                        icon: "download"
                                                      })
                                                    ])
                                                  ]),
                                                  _: 1
                                                })
                                              ], 64))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      : _createCommentVNode("", true),
                                    (
                        _ctx.statusRenewal !== 'approved' &&
                          _ctx.statusRenewal !== 'uploading' &&
                          _ctx.isEditAble
                      )
                                      ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                                          _hoisted_88,
                                          _hoisted_89,
                                          _createVNode("div", _hoisted_90, [
                                            _createVNode(_component_lp_button, _mergeProps(_ctx.styleButtonEditRenewRates, { onClick: _ctx.onEditRenewRates }), null, 16, ["onClick"])
                                          ])
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onBack", "loading", "error", "errorType", "onTryAgain", "title"])
    ]),
    _createVNode(_component_Confirmation, {
      onSuccess: _ctx.getDetail,
      isShow: _ctx.isConfirmShow,
      "onUpdate:isShow": _cache[11] || (_cache[11] = ($event: any) => (_ctx.isConfirmShow = $event)),
      typeConfirm: _ctx.typeConfirm,
      clientName: _ctx.detailData.clientName,
      renewRatesId: _ctx.detailData?.clientRenewalRate?.clientCustomRateId
    }, null, 8, ["onSuccess", "isShow", "typeConfirm", "clientName", "renewRatesId"]),
    _createVNode(_component_edit_basic_information, {
      show: _ctx.showEditBasicInformation,
      "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => (_ctx.showEditBasicInformation = $event)),
      modelValue: _ctx.detailClient,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.detailClient = $event)),
      onSuccess: _ctx.getDetail,
      onResetData: _ctx.getDetail
    }, null, 8, ["show", "modelValue", "onSuccess", "onResetData"]),
    _createVNode(_component_EditCurrentPeriode, {
      ModalShow: _ctx.isEditCurrentRate,
      onClose: () => _ctx.setEditCurrentRate(false),
      onSubmit: _ctx.onOpenSave
    }, null, 8, ["ModalShow", "onClose", "onSubmit"]),
    (_ctx.isAddRenewRates || _ctx.isUpdateRenewalRates || _ctx.isUpdateRates)
      ? (_openBlock(), _createBlock(_component_RenewRates, {
          key: 0,
          isUpdateRates: !_ctx.isAddRenewRates && !_ctx.isUpdateRenewalRates && _ctx.isUpdateRates,
          onClose: _ctx.onCloseRates,
          isAdd: _ctx.isAddRenewRates && !_ctx.isUpdateRenewalRates && !_ctx.isUpdateRates,
          onSuccess: _ctx.getDetail
        }, null, 8, ["isUpdateRates", "onClose", "isAdd", "onSuccess"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: "Perubahan Berhasil Disimpan !",
      message: `Periode harga Client “${_ctx.clientName}” berhasil diubah`,
      image: "image-modal-success",
      textSuccess: "OK",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx._onEditPeriode,
      onClose: _ctx.onCloseSave,
      title: "Konfirmasi Perubahan",
      message: 
      `Anda yakin ingin menyimpan perubahan Periode harga Client '${_ctx.clientName}' ?`
    ,
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.openSave]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: () => _ctx.onAddRenewRates(false),
      onClose: () => _ctx.setEditTerminated(false),
      title: "Yakin Keluar Halaman ?",
      message: "Anda belum selesai mengisi form. Permintaan tidak akan diproses jika Anda keluar dari halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    (_ctx.freezeUnFreezeModal)
      ? (_openBlock(), _createBlock(_component_freeze_unfreeze_popup, _mergeProps({
          key: 1,
          modelValue: _ctx.freezeUnFreezeModal,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.freezeUnFreezeModal = $event))
        }, _ctx.detailClientFreezeUnFreeze, { onSuccess: _ctx.getDetail }), null, 16, ["modelValue", "onSuccess"]))
      : _createCommentVNode("", true)
  ], 64))
}